import Repository from '@/services/Repository';

const resource = '/sighthearing-record';

export default {
  async getByStudent({ studentId, schoolYear }) {
    let path = 'students';
    let params = {
      schoolYear,
    };

    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/${path}/${studentId}`, { params })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async getFormRecordByRoom(query) {
    let path = 'sighthearing-room';
    const { students, schoolYear } = query;
    let studentIds = students.map((student) => student.id);
    let params = {
      studentIds,
      schoolYear,
    };
    console.log(params);
    return Repository.get(`/forms/${path}`, {
      params,
    });
  },
  post({ sight, hearing, student, studyClass, schoolYear }) {
    return Repository.post(`${resource}/`, {
      sight,
      hearing,
      student,
      studyClass,
      schoolYear,
    });
  },
  update({ recordId, sight, hearing }) {
    let entry = {
      sight,
      hearing,
    };
    return Repository.put(`${resource}/id/${recordId}`, entry);
  },
};
